/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'

function GroupedDates(props) {
  return (
    <svg
      viewBox="0 0 907 155"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="a" d="M0 155L906.934 155 906.934 0.53 0 0.53z" />
        <path
          id="c"
          d="M3.31954245e-15 20.2987L3.31954245e-15 0.3897 60.0788 0.3897 60.0788 20.2987z"
        />
      </defs>
      <g
        transform="translate(-211 -558) translate(211 557)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M555.847 1.977s12.627 2.763 15.348 17.622c0 0 8.79-8.81 22.937-5.71M586.655 31.033s9.718.942 13.089 11.843c0 0 5.805-7.394 16.692-6.335M524.082 10.733s9.763.14 14.02 10.726c0 0 5.175-7.847 16.114-7.688"
          stroke="#231F20"
          strokeWidth={2}
        />
        <path fill="#67C1F0" d="M175.8982 127.1037L218.0932 127.1037 196.9962 64.5077z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M175.8982 127.1037L218.0932 127.1037 196.9962 64.5077z"
        />
        <path
          d="M196.996 83.564v70.691M206.372 111.49l-9.376 8.512"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <path fill="#67C1F0" d="M254.7302 137.1032L296.9252 137.1032 275.8282 52.2232z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M254.7302 137.1032L296.9252 137.1032 275.8282 52.2232z"
        />
        <path
          d="M275.828 81.54v72.716M283.641 119.203l-7.813 5.158M263.3 102.624l12.527 13.59"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <path
          stroke="#C0C6CB"
          strokeWidth={2}
          d="M583.5876 154.028L723.4326 16.083 779.8546 70.368"
        />
        <path
          stroke="#C0C6CB"
          strokeWidth={2}
          d="M685.6267 153.8805L814.7367 37.2595 866.8267 83.1525"
        />
        <path fill="#9BE1A4" d="M857.5886 114.192L905.6816 114.192 881.6356 8.272z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M857.5886 114.192L905.6816 114.192 881.6356 8.272z"
        />
        <path
          d="M881.635 42.305V154.81M872.082 83.37l8.596 8.143M890.053 61.063l-8.418 11.507"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <path fill="#67C1F0" d="M827.0925 127.1403L869.2875 127.1403 848.1905 64.5453z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M827.0925 127.1403L869.2875 127.1403 848.1905 64.5453z"
        />
        <path
          d="M848.19 83.601v70.69M857.567 111.527l-9.377 8.512"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <g transform="translate(0 .47)">
          <path
            d="M889.994 146.914c0 4.212-3.431 7.642-7.65 7.642h-16.02v-.782h16.02a6.86 6.86 0 006.868-6.86 6.862 6.862 0 00-7.65-6.82 6.335 6.335 0 00-.226-.759c.336-.047.672-.07 1.008-.07 4.219 0 7.65 3.43 7.65 7.65z"
            fill="#231F20"
          />
          <path
            d="M882.343 140.046a6.862 6.862 0 016.869 6.868 6.86 6.86 0 01-6.869 6.861h-16.019l.095-.782h15.924c3.36 0 6.088-2.726 6.088-6.079a6.09 6.09 0 00-6.713-6.056 6.4 6.4 0 00-.155-.765 6.5 6.5 0 01.78-.047"
            fill="#231F20"
          />
          <path
            d="M881.562 140.093c.07.25.117.508.156.766-.25.031-.5.07-.742.125l-.094-.39-.086-.376c.25-.055.508-.102.766-.125"
            fill="#231F20"
          />
          <path
            d="M881.531 144.391c.195-.72.289-1.47.289-2.22 0-.445-.031-.883-.102-1.312a6.088 6.088 0 016.712 6.055 6.087 6.087 0 01-6.087 6.08h-15.924l.015-.172 10.424-9.151 3.915.517h.008l.75.203z"
            fill="#9BE1A4"
          />
          <path
            d="M881.562 140.093c-.258.023-.516.07-.766.125l-.17-.758c.233-.054.475-.1.71-.125.093.25.164.5.226.758"
            fill="#231F20"
          />
          <path
            d="M881.718 140.859c.07.43.103.867.103 1.312 0 .75-.095 1.5-.29 2.22l-.75-.203a7.836 7.836 0 00.258-2.017c0-.54-.054-1.07-.156-1.578l.093.39c.242-.054.492-.093.742-.124"
            fill="#9BE1A4"
          />
          <path
            d="M880.883 140.593a8.035 8.035 0 01-.102 3.595h-.007l-.75-.204a7.105 7.105 0 00.101-3.18l.664-.578c.039.117.063.242.094.367"
            fill="#9BE1A4"
          />
          <path
            d="M880.789 140.218h.008l.086.375c-.032-.125-.055-.25-.094-.367v-.008zM880.773 144.188l-3.915-.517 3.267-2.867a7.12 7.12 0 01-.102 3.18l.75.204zM873.193 135.1c3.423 0 6.291 2.453 6.932 5.704l-3.267 2.867-9.689-1.265a6.064 6.064 0 00-1.032-.578c.18-3.744 3.275-6.728 7.056-6.728"
            fill="#9BE1A4"
          />
          <path
            d="M876.858 143.671l-10.424 9.15 1.07-9.134.547-.555a6.008 6.008 0 00-.882-.727l9.69 1.266z"
            fill="#9BE1A4"
          />
          <path
            d="M880.625 139.46l.172.758h-.008a7.833 7.833 0 00-7.596-5.9c-4.117 0-7.493 3.172-7.821 7.212a6.48 6.48 0 00-.766-.187c.415-4.368 4.11-7.806 8.587-7.806 3.767 0 6.979 2.43 8.143 5.798-.234.023-.477.07-.711.125"
            fill="#231F20"
          />
          <path
            d="M873.193 135.1c-3.78 0-6.876 2.984-7.056 6.728a4.814 4.814 0 00-.765-.297c.328-4.04 3.704-7.212 7.821-7.212a7.834 7.834 0 017.596 5.899v.008l-.664.578c-.64-3.251-3.509-5.704-6.932-5.704"
            fill="#231F20"
          />
          <path
            d="M867.505 143.687l-1.07 9.135-.196.172h-2.86a5.11 5.11 0 01-5.102-5.103 5.11 5.11 0 015.103-5.102 5.08 5.08 0 013.578 1.454l.547-.556z"
            fill="#9BE1A4"
          />
          <path
            d="M867.169 142.406l-1.82-.234h.78c0-.118 0-.235.009-.344.359.156.703.35 1.03.578"
            fill="#231F20"
          />
          <path
            fill="#9BE1A4"
            d="M866.4343 152.8217L866.4183 152.9937 866.3253 152.9937 866.2393 152.9937z"
          />
          <path fill="#231F20" d="M866.4187 152.9935L866.3247 153.7745 866.3247 152.9935z" />
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#231F20"
            mask="url(#b)"
            d="M865.348 154.556L866.325 154.556 866.325 153.775 865.348 153.775z"
          />
          <path
            fill="#231F20"
            mask="url(#b)"
            d="M866.325 152.9935L866.325 153.7745 865.348 153.7745 866.239 152.9935z"
          />
          <path
            fill="#231F20"
            mask="url(#b)"
            d="M866.239 152.9935L865.348 153.7745 865.348 152.9935z"
          />
          <path
            d="M866.138 141.827c-.009.11-.009.227-.009.345h-.78c0-.22.007-.43.022-.642.259.078.517.172.767.297"
            fill="#231F20"
            mask="url(#b)"
          />
          <path
            d="M865.372 141.53a8.428 8.428 0 00-.023.642h-.602c-.062-.024-.117-.032-.18-.047 0-.266.016-.524.039-.781.258.046.516.109.766.187"
            fill="#231F20"
            mask="url(#b)"
          />
          <path
            d="M865.348 142.171l1.82.234c.313.211.61.453.883.727l-.547.555a5.811 5.811 0 00-2.758-1.516h.602zM864.747 142.171h-.18v-.047c.063.016.118.024.18.047"
            fill="#231F20"
            mask="url(#b)"
          />
          <path
            d="M864.567 142.171h.18a5.816 5.816 0 012.758 1.516l-.547.555a5.085 5.085 0 00-3.578-1.454 5.11 5.11 0 00-5.103 5.103 5.108 5.108 0 005.103 5.102h1.968v.782h-1.96a5.89 5.89 0 01-5.893-5.884 5.89 5.89 0 015.892-5.884c.407 0 .797.04 1.18.117v.047z"
            fill="#231F20"
            mask="url(#b)"
          />
          <path
            d="M863.38 154.556a6.671 6.671 0 01-6.666-6.665c0-3.672 2.993-6.665 6.666-6.665.414 0 .828.039 1.227.117-.024.258-.04.516-.04.781a5.864 5.864 0 00-1.18-.117c-3.25 0-5.892 2.634-5.892 5.884a5.89 5.89 0 005.893 5.884h1.96v.781h-1.968z"
            fill="#231F20"
            mask="url(#b)"
          />
        </g>
        <path
          stroke="#C0C6CB"
          strokeWidth={2}
          d="M681.7205 57.2282L703.2505 67.1002 720.5295 57.2282 746.2275 64.6502 766.1975 57.2282"
        />
        <path
          stroke="#C0C6CB"
          strokeWidth={2}
          d="M797.6345 52.7072L821.8495 59.3252 830.1845 52.7072"
        />
        <g transform="translate(0 71.47)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            d="M50.582 20.299H9.498C4.274 20.299 0 16.025 0 10.8v-.914C0 4.664 4.274.39 9.498.39h41.084c5.224 0 9.497 4.274 9.497 9.497v.914c0 5.224-4.273 9.498-9.497 9.498"
            fill="#E5E7E9"
            mask="url(#d)"
          />
        </g>
        <path
          d="M48.657 68.596c-.886 0-1.749.101-2.577.292v.014c-1.438-5.648-6.556-9.825-12.651-9.825-7.209 0-13.053 5.844-13.053 13.054l3.586 2.524a9.756 9.756 0 00-6.85-2.796c-5.407 0-9.79 4.383-9.79 9.79 0 5.407 4.383 9.791 9.79 9.791h31.545c6.309 0 11.422-5.114 11.422-11.422 0-6.308-5.113-11.422-11.422-11.422"
          fill="#E5E7E9"
        />
        <path
          d="M39.017 78.802c0 6.98 5.658 12.638 12.638 12.638 6.98 0 12.637-5.658 12.637-12.638 0-6.98-5.658-12.638-12.637-12.638-6.98 0-12.638 5.659-12.638 12.638"
          fill="#E5E7E9"
        />
        <path fill="#9BE1A4" d="M49.3122 113.6378L91.5072 113.6378 70.4102 28.7568z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M49.3122 113.6378L91.5072 113.6378 70.4102 28.7568z"
        />
        <path
          d="M78.223 95.737l-7.813 5.159M57.883 79.158l12.526 13.59"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <path
          d="M191.11 23.787c0-11.456 9.287-20.743 20.743-20.743 11.457 0 20.744 9.287 20.744 20.743 0 1.845-.24 3.633-.693 5.335M196.81 27.797a15.506 15.506 0 00-10.886-4.442c-8.592 0-15.557 6.965-15.557 15.558s6.965 15.558 15.557 15.558h50.128"
          stroke="#C0C6CB"
          strokeWidth={2}
        />
        <path
          d="M231.957 18.634a18.244 18.244 0 014.096-.465c10.024 0 18.15 8.128 18.15 18.152 0 10.023-8.126 18.15-18.15 18.15h-5.186"
          stroke="#C0C6CB"
          strokeWidth={2}
        />
        <path fill="#9BE1A4" d="M148.903 113.6378L196.996 113.6378 172.949 7.7178z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M148.903 113.6378L196.996 113.6378 172.949 7.7178z"
        />
        <path
          d="M172.949 41.75v112.506M70 56v99M161.052 82.817l8.596 8.142M181.368 60.509l-8.42 11.507"
          stroke="#0E1D25"
          strokeWidth={2}
        />
        <path fill="#FDBD99" d="M69.6286 127.2921L59.2976 130.0271 63.3646 132.7621z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M69.6286 127.2921L59.2976 130.0271 63.3646 132.7621z"
        />
        <path fill="#FDBD99" d="M172.9489 129.4479L175.8979 139.2199 179.4139 135.1059z" />
        <path
          stroke="#231F20"
          strokeWidth={2}
          d="M172.9489 129.4479L175.8979 139.2199 179.4139 135.1059z"
        />
        <path d="M155.5 131.98a6.355 6.355 0 11-12.71 0 6.355 6.355 0 0112.71 0" fill="#C0C6CB" />
        <path
          d="M155.5 131.98a6.355 6.355 0 11-12.71 0 6.355 6.355 0 0112.71 0z"
          stroke="#C0C6CB"
          strokeWidth={2}
        />
        <path
          d="M72.962 126.51s16.2 19.926 44.332 20.708c28.13.782 52.319-18.935 52.319-18.935s-41.38 8.006-51.538 7.22c-10.158-.787-45.113-8.992-45.113-8.992"
          fill="#FDBD99"
        />
        <path
          d="M72.962 126.51s16.2 19.926 44.332 20.708c28.13.782 52.319-18.935 52.319-18.935s-41.38 8.006-51.538 7.22c-10.158-.787-45.113-8.992-45.113-8.992z"
          stroke="#231F20"
          strokeWidth={2}
        />
      </g>
    </svg>
  )
}

export default GroupedDates
